import { render, staticRenderFns } from "./RegisterPersonalizationStep.vue?vue&type=template&id=4dbaacde&scoped=true"
import script from "./RegisterPersonalizationStep.vue?vue&type=script&lang=js"
export * from "./RegisterPersonalizationStep.vue?vue&type=script&lang=js"
import style0 from "./RegisterPersonalizationStep.vue?vue&type=style&index=0&id=4dbaacde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbaacde",
  null
  
)

export default component.exports